const CommonMasterModal = ({
  show,
  title,
  onClose,
  onSave,
  saveText = "Save",
  cancelText = "Cancel",
  isSaving = false,
  children,
}) => {
  if (!show) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />

      {/* Modal */}
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ zIndex: 1050 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4 p-3">
            {/* Header */}
            <div className="modal-header border-0">
              <h5 className="modal-title fs-20 fw-700">{title}</h5>
              <button
                type="button"
                className="btn-close border rounded-circle"
                onClick={onClose}
              />
            </div>

            {/* Body */}
            <div className="modal-body">{children}</div>

            {/* Footer */}
            <div className="modal-footer gap-3 border-0">
              <button
                className="btn bg-transparent border px-3"
                type="button"
                onClick={onClose}
                disabled={isSaving}
              >
                {cancelText}
              </button>

              <button
                className="btn text-white px-4"
                type="button"
                style={{ backgroundColor: "#4F46E5" }}
                onClick={onSave}
                disabled={isSaving}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                  </>
                ) : (
                  saveText
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonMasterModal;
